import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useCallback, useEffect, useRef } from 'react';
import { Loading } from '../../core/components/Loading';
import { TimelineCard } from './components/TimelineCard';
import { useTimeline } from './hooks/useTimeline';

export function TimelinePage() {
  const { certificates, loading, loadingMore, hasMore, fetchCertificates, loadMore } = useTimeline();
  const observerRef = useRef(null);

  useEffect(() => {
    fetchCertificates();
  }, [fetchCertificates]);

  // 無限スクロール用IntersectionObserver
  const sentinelRef = useCallback(
    (node) => {
      if (observerRef.current) observerRef.current.disconnect();
      if (!node || !hasMore) return;

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) loadMore();
      });
      observerRef.current.observe(node);
    },
    [hasMore, loadMore]
  );

  if (loading) return <Loading />;

  return (
    <Box>
      <Typography
        component="h1"
        sx={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}
      >
        タイムライン
      </Typography>

      {certificates.length === 0 ? (
        <Typography color="text.secondary" textAlign="center" sx={{ mt: 4 }}>
          まだ記録がありません
        </Typography>
      ) : (
        <Box sx={{ maxWidth: 600, mx: 'auto' }}>
          {certificates.map((cert) => (
            <TimelineCard key={cert.id} certificate={cert} />
          ))}

          {/* 無限スクロールセンチネル */}
          {hasMore && <Box ref={sentinelRef} sx={{ height: 1 }} />}

          {loadingMore && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <CircularProgress size={28} />
            </Box>
          )}

          {!hasMore && certificates.length > 0 && (
            <Typography color="text.secondary" textAlign="center" sx={{ py: 2 }}>
              すべての記録を表示しました
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
